'use no memo';

export const DetailsViewer = ({ details }: { details: string | null | undefined }) => {
  const trimmed = details?.trim();
  if (!trimmed) {
    return (
      <div className="text-theme-text-grey flex flex-1 items-center justify-center px-8 py-10 text-sm">
        No details available
      </div>
    );
  }

  return (
    <div className="flex min-h-0 flex-1 overflow-hidden">
      <div className="flex min-h-0 flex-1 overflow-auto px-8 py-6">
        <div className="text-theme-black text-sm leading-6 whitespace-pre-wrap">{trimmed}</div>
      </div>
    </div>
  );
};
